export function ArrowDown1({ className }: { className?: string }) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M5.49463 10.0202L0.389846 0.287863L10.5445 0.252707L5.49463 10.0202Z" fill="#3B3060" />
        </svg>
    )
}
